import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { addNewClinicService } from '../../services/clinicsService';
import { parseDropdownData } from './parser';
import { getAllAreaOfContentService } from '../../services/areaOfContentService';

import Input from '../../components/Input';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Spinner from '../../components/Spinner';
import TextArea from '../../components/TextArea';
import SubHeader from '../../components/SubHeader';
import PrimaryButton from '../../components/PrimaryButton';
import DateTimeInput from '../../components/DateTimeInput';
import DropdownSelect from '../../components/DropdownSelect';

import './styles.scss';

const CreateClinics = (props) => {
  const history = useHistory();

  const { addToast } = useToasts();

  const [loading, setLoading] = useState(false);
  const [aocId, setAocId] = useState('');
  const [aocOptions, setAOCOptions] = useState('');
  const [currentPage, setCurrentPage] = useState(null);

  const userData = {
    userName: 'Admin',
  };

  //paging
  useEffect(() => {
    if (props.location.state.page_number) {
      setCurrentPage(props.location.state?.page_number);
    }
  }, []);

  //AOC Data
  const fetchAOCData = (params) => {
    setLoading(true);

    getAllAreaOfContentService(params)
      .then((response) => {
        setLoading(false);

        if (response.code === 200) {
          const parsedDropdownData = parseDropdownData(response?.data?.results);

          setAOCOptions(parsedDropdownData);
        }
      })
      .catch((errorData) => {
        setLoading(false);
        addToast('An error occurred while trying to Get Options.', {
          appearance: 'error',
          autoDismiss: true,
        });
      });
  };

  useEffect(() => {
    const aocParams = { page: 1, limit: 100 };

    fetchAOCData(aocParams);
  }, []); // eslint-disable-line

  const handleAocSelection = (eventValue) => {
    if (eventValue) {
      setAocId(eventValue);
    }
  };

  const validateFormData = () => {
    let isFormValid = true;

    if (!aocId || aocId === '') {
      addToast('Area Of Content is a required selection.', {
        appearance: 'error',
        autoDismiss: true,
      });

      isFormValid = false;
    }

    return isFormValid;
  };

  const handleCreateClinics = () => {
    const isFormValid = validateFormData();

    if (isFormValid) {
      setLoading(true);

      const data = {
        aoc_id: aocId,
      };

      addNewClinicService(data)
        .then((responseData) => {
          setLoading(false);
          if (responseData) {
            if (responseData.code === 200 || responseData.code === 201) {
              addToast('Clinic created. Please add clinic details.', {
                appearance: 'success',
                autoDismiss: true,
              });

              history.push('/clinics/edit/' + aocId, {
                page_current: currentPage,
              });
            }
          }
        })
        .catch((err) => {
          setLoading(false);

          const errorData = err.response?.data?.errors;

          if (errorData && Object.keys(errorData).length > 0) {
            for (let key in errorData) {
              for (let e of errorData[key]) {
                addToast(e, {
                  appearance: 'error',
                  autoDismiss: true,
                });

                setLoading(false);
              }
            }
          } else if (err.response?.data?.code === 404) {
            addToast('No Api.', {
              appearance: 'error',
              autoDismiss: true,
            });
            history.push('/clinics');
          } else {
            setLoading(false);

            addToast(err.response?.data?.message, {
              appearance: 'error',
              autoDismiss: true,
            });
          }
        });
    } else {
      setLoading(false);
    }
  };

  return (
    <div className='createClinics-wrapper'>
      <Header userData={userData} />

      <Sidebar />

      <div className='flexible-container'>
        <SubHeader title='Create Clinics' />

        <div className='createClinics-wrapper-content'>
          <div className='form-section'>
            <div className='row'>
              <div className='col-12 col-sm-6 col-md-4'>
                <DropdownSelect
                  options={aocOptions}
                  label={'AOC'}
                  placeholder='Choose AOC'
                  handleChange={handleAocSelection}
                  required='yes'
                />
              </div>
            </div>

            <div className='row'>
              <div className='col-12 col-sm-6 col-md-4'>
                <PrimaryButton value='Next' handleClick={handleCreateClinics} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default CreateClinics;
